import React from 'react';
import PageLayout from './PageLayout';

export default function Support() {
  return (
    <PageLayout title="SMPW Scheduler Support">
      <p>
        SMPW Scheduler is a free tool for building volunteer schedules
        quickly. If something isn't working, here's how to get help.
      </p>

      <h2>Common questions</h2>

      <p><strong>Q: My schedule image isn't saving to my Photos.</strong></p>
      <p>
        A: On iPhone, the Share sheet that opens after you tap Save has a
        "Save Image" option toward the bottom. On Android, tap Save to
        Photos from the share sheet. If neither option appears, your OS
        may be blocking the app's access — check your device's privacy
        settings.
      </p>

      <p><strong>Q: Can I share a schedule with someone who doesn't have the app?</strong></p>
      <p>
        A: Yes. Tap Share and choose Messages, Mail, or any other app.
        The schedule sends as a PNG image — the recipient doesn't need
        SMPW Scheduler installed.
      </p>

      <p><strong>Q: Does my schedule sync between devices?</strong></p>
      <p>
        A: No. Schedules are stored only on the device where you created
        them. There's no account system, so nothing syncs across devices.
      </p>

      <p><strong>Q: Does the app work offline?</strong></p>
      <p>
        A: Yes. Once installed, schedule building works fully offline.
        The only feature that needs a network is the global counter that
        tracks total schedules generated.
      </p>

      <p><strong>Q: How do I report a bug or request a feature?</strong></p>
      <p>
        A: Email{' '}
        <a href="mailto:branleeharris@gmail.com">branleeharris@gmail.com</a>
        {' '}with a short description and, if possible, a screenshot.
        Please include your device model and OS version.
      </p>

      <h2>Contact</h2>
      <p>
        Support email:{' '}
        <a href="mailto:branleeharris@gmail.com">branleeharris@gmail.com</a>
      </p>
      <p>Typical response time: within a few days.</p>
    </PageLayout>
  );
}
